const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgExcludeProvider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.16,54.33c9,0,16.31-7.91,16.31-17.77,0-9.62-7.28-17.29-16.31-17.29S49.85,27,49.9,36.66,57.17,54.33,66.16,54.33Zm0-5.08c-5.91,0-10.84-5.51-10.84-12.59,0-6.89,4.88-12.26,10.84-12.26s10.89,5.27,10.89,12.16C77.05,43.64,72.12,49.25,66.16,49.25Zm0,10.11A37.84,37.84,0,0,0,47.7,63.9a20.45,20.45,0,0,1,3.86,3.86,32.25,32.25,0,0,1,14.6-3.27c17.77,0,27.73,11.81,27.73,18.6,0,1-.49,1.37-1.85,1.37H57.56a19.65,19.65,0,0,1-.83,5.13H90.52c6,0,8.79-1.86,8.79-5.86C99.31,73.72,86.72,59.36,66.16,59.36ZM33.54,102.53a19.24,19.24,0,0,0,0-38.48,19.24,19.24,0,0,0,0,38.48Zm-10-17a2.2,2.2,0,1,1,0-4.39H43.45a2.2,2.2,0,1,1,0,4.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcludeProvider);
export default __webpack_public_path__ + "static/media/excludeProvider.161259898891b2a366ad5355726daef4.svg";
export { ForwardRef as ReactComponent };